$(function() {
    $('[data-interactive-patient-record]').each(function() {
        var self = this;
        init({}, {
            trans: {
                see: document.querySelector('meta[name=see]').content,
                quantity: document.querySelector('meta[name=quantity]').content,
                hour: document.querySelector('meta[name=hour]').content,
                weekDay: document.querySelector('meta[name=week-day]').content,
                startIntake: document.querySelector('meta[name=start-intake]').content,
                endIntake: document.querySelector('meta[name=end-intake]').content,
                openFile: document.querySelector('meta[name=open-file]').content
            },
            els: {
                home: $('[data-page=home]', self).get(0),
                healthIndicators: $('[data-page=health-indicators]', self).get(0),
                clinicalHistory: $('[data-page=clinical-history]', self).get(0),
                clinicalHistoryDetails: $('[data-page=clinical-history-details]', self).get(0),
                pillBox: $('[data-page=pill-box]', self).get(0),
                pillBoxDetails: $('[data-page=pill-box-details]', self).get(0),
                appointments: $('[data-page=appointments]', self).get(0),

                listClinicalRecords: $('[data-list-clinical-records]', self).get(0),
                detailsClinicalRecords: $('[data-details-clinical-records]', self).get(0),
                listPills: $('[data-list-pills]', self).get(0),
                detailsPills: $('[data-details-pills]', self).get(0),
                listCalendar: $('[data-list-calendar]', self).get(0),
            },
            urls: {
                pills: $('[name=pills]', self).get(0).content,
                calendar: $('[name=calendar]', self).get(0).content,
                clinicalRecords: $('[name=clinical-records]', self).get(0).content,
            },
            collections: {
                pills: [],
                calendar: [],
                clinicalRecords: [],
            }
        }, self);
    });
    function init(params, data, self) {
        window.addEventListener('hashchange', function() {
            panelChangeHandler(data);
        }, false);
        location.hash = '#home';
        panelChangeHandler(data);
        fetchPills(data);
        fetchCalendar(data);
        fetchClinicalRecords(data);

        $(data.els.pillBox).on('click', '[data-id]', (ev) => {
            clickHandler_Pills(data, parseInt(ev.currentTarget.dataset.id));
        });
        $(data.els.clinicalHistory).on('click', '[data-id]', (ev) => {
            clickHandler_ClinicalRecord(data, parseInt(ev.currentTarget.dataset.id));
        });
        $(data.els.clinicalHistoryDetails).on('click', '[data-file]', (ev) => {
            ev.preventDefault();
            clickHandler_clinicalHistoryDetails(data, ev.currentTarget.href, ev.currentTarget.dataset.file);
        });
    }
    function panelChangeHandler(data) {
        cleanAllPages(data);
        if ("#health-indicators" === location.hash) {
            data.els.healthIndicators.classList.add('interactive-patient-record__page--is-active');
        } else if ("#clinical-history" === location.hash) {
            data.els.clinicalHistory.classList.add('interactive-patient-record__page--is-active');
        } else if ("#clinical-history-details" === location.hash) {
            data.els.clinicalHistoryDetails.classList.add('interactive-patient-record__page--is-active');
        } else if ("#pill-box" === location.hash) {
            data.els.pillBox.classList.add('interactive-patient-record__page--is-active');
        } else if ("#pill-box-details" === location.hash) {
            data.els.pillBoxDetails.classList.add('interactive-patient-record__page--is-active');
        } else if ("#appointments" === location.hash) {
            data.els.appointments.classList.add('interactive-patient-record__page--is-active');
        } else {
            data.els.home.classList.add('interactive-patient-record__page--is-active');
        }
    }
    function cleanAllPages(data)
    {
        data.els.home.classList.remove('interactive-patient-record__page--is-active');
        data.els.healthIndicators.classList.remove('interactive-patient-record__page--is-active');
        data.els.clinicalHistory.classList.remove('interactive-patient-record__page--is-active');
        data.els.clinicalHistoryDetails.classList.remove('interactive-patient-record__page--is-active');
        data.els.pillBox.classList.remove('interactive-patient-record__page--is-active');
        data.els.pillBoxDetails.classList.remove('interactive-patient-record__page--is-active');
        data.els.appointments.classList.remove('interactive-patient-record__page--is-active');
    }

    function fetchPills(data) {
        fetch(data.urls.pills).then(response => response.json()).then((collection) => {
            data.collections.pills = collection.data;
            renderPills(data);
        });
    }
    function fetchCalendar(data) {
        fetch(data.urls.calendar).then(response => response.json()).then((collection) => {
            data.collections.calendar = collection.data;
            renderCalendar(data);
        });
    }
    function fetchClinicalRecords(data) {
        fetch(data.urls.clinicalRecords).then(response => response.json()).then((collection) => {
            data.collections.clinicalRecords = collection.data;
            renderClinicalRecords(data);
        });
    }

    function renderPills(data) {
        var html = [];
        data.collections.pills.forEach(element => {
            var row = [
                '<div class="interactive-patient-record__item-2 interactive-patient-record__item-2--is-style-3">',
                    '<div class="interactive-patient-record__item-2__icon">', element.type, '</div>',
                    '<div>',
                        '<h1 class="interactive-patient-record__item-2__title">', element.name, '</h1>',
                    '</div>',
                    '<a data-no-loading data-id="', element.id, '" class="focusable focusable--is-level-1 interactive-patient-record__item-2__action" href="#pill-box-details">', data.trans.see, '</a>',
                '</div>'
            ];
            html.push(row.join(''));
        });
        data.els.listPills.innerHTML = html.join('');
    }
    function renderCalendar(data) {
        var html = [];
        data.collections.calendar.forEach(element => {
            var row = [
                '<div class="interactive-patient-record__item-3">',
                    '<div class="interactive-patient-record__item-3__icon">',
                        '<span>', element.day, '</span>',
                        '<span>', element.month, '</span>',
                    '</div>',
                    '<div>',
                        '<h1 class="interactive-patient-record__item-3__title">', element.name, '</h1>',
                        '<div class="interactive-patient-record__item-3__info"><i class="interactive-patient__icon interactive-patient__icon--is-home"></i> ', element.location, '</div>',
                        '<div class="interactive-patient-record__item-3__info"><i class="interactive-patient__icon interactive-patient__icon--is-time"></i> ', element.hour, '</div>',
                    '</div>',
                '</div>'
            ];
            html.push(row.join(''));
        });
        data.els.listCalendar.innerHTML = html.join('');
    }
    function renderClinicalRecords(data) {
        var html = [];
        data.collections.clinicalRecords.forEach(element => {
            var row = [
                '<div class="interactive-patient-record__item-2">',
                    '<div>',
                        '<h1 class="interactive-patient-record__item-2__title">', element.name, '</h1>',
                        '<div class="interactive-patient-record__item-2__pass-date">',
                            '<span class="interactive-patient-record__item-2__pass">', element.timePass, '</span>',
                            '<span class="interactive-patient-record__item-2__date">', element.date, '</span>',
                        '</div>',
                   '</div>',
                    '<a data-no-loading data-id="', element.id, '" class="focusable focusable--is-level-1 interactive-patient-record__item-2__action" href="#clinical-history-details">', data.trans.see, '</a>',
                '</div>'
            ];
            html.push(row.join(''));
        });
        data.els.listClinicalRecords.innerHTML = html.join('');
    }

    function clickHandler_Pills(data, id) {
        for (const item of data.collections.pills) {
            if (id === item.id) {
                renderPillsDetails(data, item);
                return;
            }
        }
    }
    function clickHandler_ClinicalRecord(data, id) {
        for (const item of data.collections.clinicalRecords) {
            if (id === item.id) {
                renderClinicalRecordsDetails(data, item);
                return;
            }
        }
    }
    function clickHandler_clinicalHistoryDetails(data, url, contentType) {
        var content = '<img class="interactive-patient-clinical-record-popup__img" src="' + url + '">';

        if (!contentType.includes('image')) {
            content = '<object data="' + url + '" type="'+contentType+'" style="min-height: calc(100vh - 100px); min-width: calc(100vw - 100px);"><p>Ficheiro não é suportado</p></object>';
        }

        var row = [
            '<div class="interactive-patient-clinical-record-popup">',
                '<div class="interactive-patient-clinical-record-popup__content">',
                    '<div class="interactive-patient-clinical-record-popup__wrapper">',
                        content,
                    '</div>',
                    '<div class="focusable focusable--is-level-1 interactive-patient-clinical-record-popup__close" data-close>X</div>',
                '</div>',
            '</div>'
        ];

        $popup = $(jQuery.trim(row.join('')));
        $(data.els.detailsClinicalRecords).append($popup);

        $popup.on('click', '[data-close]', function() {
            $popup.remove();
        });
    }

    function renderPillsDetails(data, item) {
        var row = [
            '<div class="interactive-patient-pills__details">',
                '<div class="interactive-patient-pills__header">', item.type, '<span class="interactive-patient-pills__title">',item.name, '</span></div>',
                '<div class="interactive-patient-pills__field"><span>', data.trans.quantity ,'</span>', item.quantity, '</div>',
                '<div class="interactive-patient-pills__field"><span>', data.trans.hour ,'</span>', item.hours, '</div>',
                '<div class="interactive-patient-pills__field"><span>', data.trans.weekDay ,'</span>', item.week, '</div>',
                '<br>',
                '<div class="interactive-patient-pills__field interactive-patient-pills__field--is-s"><span>', data.trans.startIntake ,'</span>', item.start, '</div>',
                '<div class="interactive-patient-pills__field interactive-patient-pills__field--is-s"><span>', data.trans.endIntake ,'</span>', item.end, '</div>',
            '</div>'
        ];
        data.els.detailsPills.innerHTML = row.join('');
    }
    function renderClinicalRecordsDetails(data, item) {
        console.log(item);
        var row = [
            '<div class="interactive-patient-clinical-record__details">',
                '<div class="interactive-patient-clinical-record__title">', item.name, '</div>',
                '<div class="interactive-patient-clinical-record__date">', item.date, '</div>',
                /*'<div class="interactive-patient-clinical-record__">', item.type, '</div>',*/
                (item.note == '' ? '' : '<div class="interactive-patient-clinical-record__note">' + item.note + '</div>'),
                (item.attach ? '<a data-no-loading class="focusable focusable--is-level-1 interactive-patient-clinical-record__action" href="/files/document/'+ item.attach+ '/" data-file="'+ item.contentType + '" target="_blank">'+ data.trans.openFile +'</a>' : ''),
            '</div>'
        ];
        data.els.detailsClinicalRecords.innerHTML = row.join('');
    }
});
